module.exports = __webpack_public_path__ + "img/naukri.e5601807.svg";